const global = global || window;
const env = require("services/env");
const router = require("services/router");

// polyfill if in browser
if (env.client()) {
	require("bootstrap/polyfill")();
}


const {createPipeline} = require("cleopatra");
const documentReady = require("helpers/documentReady");
const {reportOnly} = require("helpers/errors");
const browser = require("services/browser");
const renderer = require("services/renderer");
const preloader = require("services/preloader");
const maps = require("services/maps");

// Create pipelines
let ready = createPipeline().report(reportOnly);
let bootstrap = createPipeline().report(reportOnly).capture(ready);

let triggerLoadedPromise;

const loaded = new Promise((resolve, reject) => {
   triggerLoadedPromise = () => {
       resolve();
   }
});


loaded.trigger = triggerLoadedPromise;
loaded.then(() => {
   //Do some stuff
});

module.exports = {
	bootstrap,
	ready,
	loaded
};

/////////////////////////////////
// Moment
/////////////////////////////////

bootstrap.pipe(payload => {
	const moment = require("moment-timezone");
	moment.locale("da");
	moment.tz.setDefault("Europe/Copenhagen");
	moment.suppressDeprecationWarnings = true;

	// Configure moment on nevermore
	require("nevermorejs").moment(moment => moment.locale("da"));

	return payload;
});

/////////////////////////////////
// Client booting
/////////////////////////////////

bootstrap.pipe(payload => env.client() ? payload : false);

/////////////////////////////////
// Router
/////////////////////////////////

bootstrap.pipe(payload => {
	router.initialize();
	return payload;
});

/////////////////////////////////
// Maps
/////////////////////////////////

bootstrap.pipe(payload => {
	global.initMaps = maps.initializer;
	return payload;
});

/////////////////////////////////
// Renderer
/////////////////////////////////

ready.pipe(payload => {
	renderer.render();
	return payload;
});

/////////////////////////////////
// document.ready
/////////////////////////////////

bootstrap.pipe(payload => documentReady(payload));

/////////////////////////////////
// Add browser class to body
/////////////////////////////////

bootstrap.pipe(payload => {
	let classList = document.body.className.split(" ");
	const {name, version} = browser;

	classList.push(`browser-${name}`);
	classList.push(`browser-${name}-${version}`);

	document.body.className = classList.join(" ");

	return payload;
});

/////////////////////////////////
// axios
/////////////////////////////////

const axios = require("axios");

bootstrap.pipe(payload => {

	// Specify the X-Request-With header so that the Laravel backend knows
	// we are requiring it through ajax
	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

	// Register the CSRF token provided by Laravel
	// This will also act as our main authentication method
	// for Passport
	let token = env.csrfToken();

	if (token == undefined) {
		throw new Error("Cannot setup axios because the CSRF token is missing!");
	}

	axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

	return payload;
});

/////////////////////////////////
// Preloader
/////////////////////////////////

ready.capture(payload => {
	preloader.hide();
	return payload;
});



// WEBPACK FOOTER //
// ./resources/js/bootstrap/index.js